import { omitBy, isNil } from 'lodash'
import * as components from 'src/components'
import { mapGetters, mapActions } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import { oneOf } from 'src/utils'
import { CodePartial } from 'src/partials/security'
import { Constants } from 'src/constants'

export default {
  components: {
    ...components,
    CodePartial
  },
  computed: {
    ...mapGetters({
      context: 'passport/context',
      user: 'passport/user',
      verificator: 'passport/defaultVerificator'
    }),
    isTimexScope () {
      return this.context == null || this.context.client.options.colorTheme === Constants.colorTheme.TIMEX
    },
    isSkipGrantPage () {
      const res = this.isGrantsLoaded
        && this.grants.length === 0
        && this.isAutoGrantEnabled
      return res
    }
  },
  data () {
    return {
      mode: 'selection',
      error: null,
      isErrorVisible: false,
      isBusy: false,
      isForwarding: false,
      grants: [],
      isGrantsVisible: false,
      isGrantsLoading: false,
      isGrantsLoaded: false,
      isAutoGrantEnabled: false,
      confirmationForm: {
        code: ''
      },
      colorTheme: Constants.colorTheme
    }
  },
  validations: {
    confirmationForm: {
      code: {
        required,
        isComplex () {
          return this.confirmationForm.code.length === 6
        }
      }
    }
  },
  watch: {
    'confirmationForm.code': {
      async handler () {
        const code = this.confirmationForm.code || ''
        if (code.length === 6) {
          await this.handleConfirm()
        }
      }
    }
  },
  created () {
    if (this.context && this.context.client.options.autoGrant) {
      this.isAutoGrantEnabled = true
    }
  },
  mounted () {
    this.isGrantsLoading = true
    setImmediate(async () => {
      try {
        const [availableScopes, myGrants] = await Promise.all([
          this.fetchAvailableScopes(),
          this.fetchMyGrants()
        ])

        this.grants = availableScopes
          .filter(e => myGrants.includes(e.resourceString))
          .map(e => ({
            name: e.resourceString,
            isActive: true,
            description: e.description
          }))

        if (this.grants.length === 0 && this.isAutoGrantEnabled) {
          await this.handleSubmit()
        }

        this.isGrantsLoaded = true
      } finally {
        this.isGrantsLoading = false
      }
    })
  },
  methods: {
    ...mapActions({
      signout: 'passport/signout',
      grant: 'passport/grant',
      fetchMyGrants: 'passport/fetchMyGrants',
      fetchAvailableScopes: 'passport/fetchAvailableScopes',
      describeError: 'errors/describeError'
    }),
    oneOf,
    // async confirmCode () {
    //   this.$v.confirmationForm.$touch()
    //   if (!this.$v.confirmationForm.$invalid) {
    //     this.handleConfirm()
    //   }
    // },
    async handleShowGrants () {
      this.isGrantsVisible = true
    },
    async handleBack () {
      if (this.mode === 'confirmation') {
        this.confirmationForm.code = null
        this.mode = 'selection'
        if (this.isSkipGrantPage) {
          this.$router.push('/security/signin')
        }
      } else {
        await this.handleReset()
      }
    },
    async handleSubmit () {
      if (this.verificator == null) {
        await this.handleGrant()
      } else {
        await this.handleConfirmationRequired()
      }
    },
    async handleConfirmationRequired () {
      this.mode = 'confirmation'
    },
    async handleConfirm () {
      await this.handleGrant()
    },
    async handleGrant () {
      this.isBusy = true
      this.isErrorVisible = false
      this.error = null
      setImmediate(async () => {
        try {
          const { state, redirectUrl, codeChallenge } = this.context
          const { code } = await this.grant({
            code: this.verificator == null ? null : this.confirmationForm.code,
            grants: this.grants.filter(g => this.isAutoGrantEnabled || g.isActive).map(g => g.name),
            codeChallenge
          })

          const params = omitBy({
            code,
            state
          }, isNil)

          const qs = Object.keys(params).map(k => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`).join('&')

          this.isForwarding = true
          document.location.href = `${redirectUrl}?${qs}`
        } catch (e) {
          if (e.response && e.response.status === 403) {
            // eslint-disable-next-line
            this.handleReset()
            return
          }
          const { errorMessage } = await this.describeError({ error: e })
          this.error = errorMessage
          this.isErrorVisible = true
        } finally {
          this.isBusy = false
        }
      })
    },
    async handleReset () {
      this.signout()
      this.$router.push('/security/signin')
    },
    async handleCode (code) {
      this.confirmationForm.code = code
      // await this.handleConfirm()
    }
  }
}
